import React, {useState} from 'react';
import {useAuth} from '../../context/AuthContext';
import {useNavigate, useLocation} from 'react-router-dom';
import SPLogo from "../../assets/SP_Logo.svg";


function Login() {
    const location = useLocation();
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(location.state?.error || '');
    const navigate = useNavigate();
    const {login} = useAuth();
    const [isLoading, setIsLoading] = useState(false);


// Parent Component: Login
    const handleLogin = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            await login(identifier, password, navigate);
        } catch (error) {
            if (error.response && error.response.status === 429) {
                console.error('Zu viele Login-Versuche. Bitte versuche es später erneut.');
                setError('Zu viele Login-Versuche. Bitte versuche es später erneut.');
            } else {
                console.error('Anmeldung fehlgeschlagen:', error);
                setError('Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.');
            }
        } finally {
            setIsLoading(false); // Ladezustand auf false setzen, egal ob erfolgreich oder nicht
        }
    };


    return (
        <div className="flex min-h-screen flex-col justify-center px-6 py-12 bg-gray-100 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                <img
                    alt="AES"
                    src={SPLogo}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/fallback-logo.png';
                    }}
                    className="mx-auto h-16 w-auto"
                />
                <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
                    Sign in SolidFlow
                </h2>
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                        <label htmlFor="identifier" className="block text-sm font-medium text-gray-900">
                            Benutzername oder Email
                        </label>
                        <div className="mt-2">
                            <input
                                id="identifier"
                                name="identifier"
                                type="text"
                                required
                                value={identifier}
                                onChange={(e) => setIdentifier(e.target.value)}
                                autoComplete="identifier"
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border border-gray-500 placeholder:text-gray-400 focus:border-indigo-600 sm:text-sm"
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    <div>
                        <div className="flex items-center justify-between">
                            <label htmlFor="password" className="block text-sm font-medium text-gray-900">
                                Passwort
                            </label>
                        </div>
                        <div className="mt-2">
                            <input
                                id="password"
                                name="password"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="current-password"
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border border-gray-500 placeholder:text-gray-400 focus:border-indigo-600 sm:text-sm"
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    {/* Fehlermeldung */}
                    {error && (
                        <div className="text-red-500 text-sm text-center bg-red-100 p-2 rounded">
                            {error}
                        </div>
                    )}

                    <div>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            {isLoading ? 'Wird geladen...' : 'Login'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Login;